import { anyRoomListName } from 'owa-locstrings/lib/strings/anyroomlistname.locstring.json';
import loc from 'owa-localize';
import { makeGetRequest } from 'owa-ows-gateway';
import PlacesFilters from '../schema/PlacesFilters';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Performs a request to the Places API to fetch all room lists
 */
export function getRoomLists(city?: string): Promise<Response> {
    let endpoint: string = isFeatureEnabled('cal-mf-placesb2')
        ? 'LocationsB2/odata/api/v1.0/Localities/?$orderby=Name&$top=500'
        : 'Locations/odata/api/v1.0/Localities/?$orderby=Name&$top=500';

    if (city) {
        endpoint += `&$filter=contains(tolower(Address/City), '${encodeURIComponent(
            city.toLowerCase()
        )}')`;
    }

    return makeGetRequest(endpoint, undefined, true, undefined, undefined, undefined, 'localities');
}

/**
 * Performs a request to the Places API to search for rooms based on the provided filters
 * @param placesFilters: The room filters
 */
export function searchRooms(placesFilters: PlacesFilters = null): Promise<Response> {
    const placesEndpoint: string = isFeatureEnabled('cal-mf-placesb2')
        ? 'LocationsB2/odata/api/v1.0/Places/?&$top=100&$orderby=Name'
        : 'Locations/odata/api/v1.0/Places/?&$top=100&$orderby=Name';

    let endpoint: string = placesEndpoint;
    let filterParts: string[] = [];

    if (placesFilters) {
        if (
            placesFilters.roomListEmails &&
            placesFilters.roomListEmails.length > 0 &&
            placesFilters.roomListEmails.some(x => x != loc(anyRoomListName))
        ) {
            let roomListsfilterParts: string[] = [];
            placesFilters.roomListEmails.forEach(roomList => {
                roomListsfilterParts.push(
                    `Localities/any(locality: locality eq '${encodeURIComponent(roomList)}')`
                );
            });
            filterParts.push(`(${roomListsfilterParts.join(' or ')})`);
        }

        if (placesFilters.cities && placesFilters.cities.length > 0) {
            // Search by City.  For instance if the filter value is "Redmond" the filter part
            // would look like "contains(tolower(Address/City), 'redmond')"
            let citiesFilterParts: string[] = [];
            placesFilters.cities.forEach(city => {
                citiesFilterParts.push(
                    `contains(tolower(Address/City), '${encodeURIComponent(city.toLowerCase())}')`
                );
            });

            filterParts.push(`(${citiesFilterParts.join(' or ')})`);
        }
    }

    if (filterParts.length > 0) {
        // If filters were specified, construct the final URL by concatenating all filter parts
        endpoint += '&$filter=' + filterParts.join(' or ');
    }

    return makeGetRequest(endpoint, undefined, true, undefined, undefined, undefined, 'places');
}
